import React, { useEffect, useState, useRef } from "react";
import Navbar from "../navbar";
import Features from "./Features";
import FindJob from "./FindJob";
import Footer from "../footer";
import Home from "./Home";
import PartnerInstitution from "./PartnerInstitution";
import Process from "./Process";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { changeLayoutMode } from "../../../../slices/thunks";

const CareerAndJob = () => {
  const dispatch = useDispatch();
  const homeRef = useRef(null); // Reference for scrolling to the Home section
  const [selectedJobType, setSelectedJobType] = useState("");

  const selectLayoutState = (state) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout) => ({
      layoutModeType: layout.layoutModeType,
    })
  );
  const { layoutModeType } = useSelector(selectLayoutProperties);

  useEffect(() => {
    if (layoutModeType) {
      window.dispatchEvent(new Event("resize"));
      dispatch(changeLayoutMode(layoutModeType));
    }
  }, [layoutModeType, dispatch]);

  // Handle job type selection
  const handleSelectJob = (jobType) => {
    setSelectedJobType(jobType);
    if (homeRef.current) {
      homeRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const onChangeLayoutMode = (value) => {
    if (changeLayoutMode) {
      dispatch(changeLayoutMode(value));
    }
  };

  document.title = "Job Landing";

  window.onscroll = function () {
    scrollFunction();
  };

  const scrollFunction = () => {
    const element = document.getElementById("back-to-top");
    if (element) {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        element.style.display = "block";
      } else {
        element.style.display = "none";
      }
    }
  };

  const toTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  return (
    <React.Fragment>
      <div className="layout-wrapper landing">
        <Navbar />
        <Process />
        <Features />
        {/* Pass handler to FindJob */}
        <FindJob onSelectJob={handleSelectJob} />
        <PartnerInstitution />
        {/* Pass selectedJobType and ref to Home */}
        <div ref={homeRef}>
          <Home selectedJobType={selectedJobType} />
        </div>
        <Footer />

        <button
          onClick={() => toTop()}
          className="btn btn-info btn-icon landing-back-top"
          id="back-to-top"
        >
          <i className="ri-arrow-up-line"></i>
        </button>
      </div>
    </React.Fragment>
  );
};

export default CareerAndJob;
